import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('noAircraftCard');

    return {
        MESSAGE_USER: t('messageUser'),
        TITLE: t('title')
    };
};

export default useTranslation;
